import React from 'react'
import AccountDetails from './account-details'
import {
  AccountContainer,
  OutlineAccountCenterContainer,
  StyledAccountCenterContainer,
  StyledAccountCenterWrapper,
} from './styled'
import TransactionsContainer from './transactions/components/container'

interface AccountCenterProps {
  show: boolean
  clickControlReference: React.RefObject<HTMLDivElement>
}

/**
 * Wrapper for the account center
 * @returns
 */
const AccountCenter: React.FC<AccountCenterProps> = ({ show, clickControlReference }) => {
  return (
    <OutlineAccountCenterContainer isBlurred={show}>
      <StyledAccountCenterContainer show={show}>
        <StyledAccountCenterWrapper ref={clickControlReference}>
          <AccountContainer>
            <AccountDetails />
            <TransactionsContainer />
          </AccountContainer>
        </StyledAccountCenterWrapper>
      </StyledAccountCenterContainer>
    </OutlineAccountCenterContainer>
  )
}

export default AccountCenter
